import '../10. Battle/Library/LibraryBoxBattle.scss'
import NP from "../1. Core/NP";
import Control from "../1. Core/Control";
import ListGroupHeader from "../1. Core/Controls/ListBox/ListGroupHeader";
import Delegate from "../1. Core/Delegate";
import IconSelect from "../1. Core/Controls/Select/IconSelect";
import {getTournaments, ITournament} from "../10. Battle/Util";
import {SportType} from "../10. Battle/types";

export default class JudgesFilterPanel extends Control {

	public EvFilterSortChanged: Delegate;

	private _sortFieldCombo: IconSelect;
	private _sortDirectionCombo: IconSelect;
	private _tournamentCombo: IconSelect;

	_initFields(settings: object)
	{
		this.EvFilterSortChanged = new Delegate();
		super._initFields(settings);
	}

	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_render()
	{
		this._initComponent('<div class="filter-panel"></div>');

		new ListGroupHeader({
			ParentNode: this._root,
			RK: 'Parameters',
			Class: 'app-list-group__subheader--accent'
		});

		this._tournamentCombo = new IconSelect({
			ParentNode: this._root,
			FloatingLabel: NP.RM.getString('Tournaments'),
			SelectedIndex: 0,
			Items: [{
				Value: null,
				FontImage: NP.FontImages.event,
				Content: NP.RM.getString('AllTournaments')
			}],
			EvItemSelected: () => this._applyFiltersSort()
		});

		new ListGroupHeader({
			ParentNode: this._root,
			RK: 'OrderBy',
			Class: 'app-list-group__subheader--accent'
		});

		this._sortFieldCombo = new IconSelect({
			ParentNode: this._root,
			SelectedIndex: 0,
			Items: [{
				Value: 'Name',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('SortByName')
			}, {
				Value: 'Country',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('SortByCountry')
			}, {
				Value: 'Rating',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('SortByRating')
			}, !NP.isTha() && {
				Value: 'Qualification',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('SortByQualification')
			}, {
				Value: 'BoutsCount',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('BoutsCount')
			}],
			EvItemSelected: () => this._applyFiltersSort()
		});

		this._sortDirectionCombo = new IconSelect({
			ParentNode: this._root,
			SelectedIndex: 0,
			Items: [{
				Value: -1,
				FontImage: NP.FontImages.arrow_downward,
				Content: NP.RM.getString('Desc')
			}, {
				Value: 1,
				FontImage: NP.FontImages.arrow_upward,
				Content: NP.RM.getString('Asc')
			}],
			EvItemSelected: () => this._applyFiltersSort()
		});

		this._renderItems([this._root], this._ParentNode || document.documentElement);
		this._loadFilters();
	}

	_loadFilters()
	{
		getTournaments(SportType.MMA).then((res: ITournament[]) =>
		{
			if (this._tournamentCombo)
			{
				let items = res.map(t => ({Value: t.Id, FontImage: NP.FontImages.event, Content: t.Name})),
					 defaultItems = [{Value: null as any, FontImage: NP.FontImages.event, Content: NP.RM.getString('AllTournaments')}];
				this._tournamentCombo.clear();
				this._tournamentCombo.addItems(defaultItems);
				this._tournamentCombo.addItems(items);
				this._tournamentCombo.setSelectedIndex(0, false);
			}
		});
	}

	_applyFiltersSort()
	{
		this.EvFilterSortChanged.fire(this, this.getFilterData())
	}

	getFilterData()
	{
		return {
			TournamentId: this._tournamentCombo.getValue(),
			SortField: this._sortFieldCombo.getValue(),
			SortDirection: this._sortDirectionCombo.getValue(),
		}
	}

	setSortValues(sortField: string, sortDirection: number)
	{
		this._sortFieldCombo.setValue(sortField, false);
		this._sortDirectionCombo.setValue(sortDirection, false);
	}
};